export default "__VITE_ASSET__CdTQiBbo__"